<template>
  <div>
    <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
      <form @submit.prevent="sendEmail">
        <div class="mb-4">
          <label for="recipientEmail" class="block text-sm font-medium text-gray-700 mb-1">Test Email Address</label>
          <b-input
              id="recipientEmail"
              v-model="localRecipientEmail"
              type="email"
              placeholder="your@email.com"
              required
          />
          <small>Enter the email address to receive the test email</small>
        </div>
        <div class="mb-4">
          <label for="recipientName" class="block text-sm font-medium text-gray-700 mb-1">Recipient First Name</label>
          <b-input
              id="recipientName"
              v-model="localRecipientName"
              type="text"
              placeholder="Jane"
              required
          />
          <small>This name will replace [FirstName] in your text</small>
        </div>
        <b-btn
            class="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 w-100"
            :disabled="isSending || !localRecipientName || !localRecipientEmail"
            type="submit"
        >
          <i class="uil uil-fast-mail mr-2"></i>
          {{ isSending ? 'Sending...' : 'Send Test Email' }}
        </b-btn>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import axios from 'axios';

export default {
  name: 'EmailTester',
  props:{
    // eslint-disable-next-line vue/no-dupe-keys
    imageId:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      localRecipientName: '',
      localRecipientEmail: '',
      error: '',
      success: '',
      isSending: false,
    };
  },
  computed: {
    ...mapState('imageEditor',[
      'imagePreview',
      'overlaySettings',
      'recipientName',
      'recipientEmail',
      'isGifMode'
    ]),
    user() {
      return this.$store.getters['auth/user']
    },
  },
  methods: {
    ...mapMutations('imageEditor',[
      'SET_RECIPIENT_NAME',
      'SET_RECIPIENT_EMAIL',
      'SET_IS_SENDING'
    ]),

    async sendEmail() {
      if (!this.localRecipientName || !this.localRecipientEmail) {
        this.error = 'Please fill out all fields';
        return;
      }

      this.error = '';
      this.success = '';
      this.isSending = true;
      this.SET_IS_SENDING(true);

      try {
        // Update store with recipient info
        this.SET_RECIPIENT_NAME(this.localRecipientName);
        this.SET_RECIPIENT_EMAIL(this.localRecipientEmail);


        // Prepare request data

        const payload = {
          text_content: '',
          first_name: this.localRecipientName,
          email_address: this.localRecipientEmail,
        };

        // Send request to server
        await axios.post(`/businesses/test-overlay-email/${this.user.business.id}/${this.imageId}`, payload);

      } catch (error) {
        console.error('Error sending email:', error);
      } finally {
        this.isSending = false;
        this.SET_IS_SENDING(false);
      }
    }
  }
};
</script>
